var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{attrs:{"id":"logo-container"}},[(_vm.ImgOrIcon === 'img')?_c('LogoImg'):_vm._e(),(_vm.ImgOrIcon === 'icon' || _vm.ImgOrIcon == null)?_c('LogoIcon'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }